// 挂牌
export const LISTING_LIST_PAGE_UUID = '7db31fd7-15ea-4e41-86dc-f546d7d120eb'

// 挂牌管理操作权限
export const LISTING_MANAGE_ACTION_UUID = 'f2aff458-5f79-4281-b795-f3ded3dbf194'
